export class CertificacionAdicional {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            razon_social: {
                value: '',
                header: 'Razón social:',
                table: true,
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Campo requerido'
            },
            tipo_identificacion: {
                value: null,
                header: 'Tipo de identificación:',
                table: true,
                required: 'Seleccione alguna opción'
            },
            identificacion: {
                value: '',
                header: 'Número de identificación:',
                table: true,
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
                required: 'Campo requerido'
            },
            estatus: {
                value: null,
                header: 'Estatus de la persona que ejerce el control (*):',
                table: true,
                required: 'Seleccione alguna opción'
            },
        }
    }
}
